/* Velune : petites interactions communes (pastilles de couleur des cartes produit). */
(function () {
  document.addEventListener('click', function (e) {
    var sw = e.target.closest('.vl-card__swatch');
    if (!sw) return;
    var card = sw.closest('[data-vl-card]');
    card.querySelectorAll('.vl-card__swatch').forEach(function (b) { b.setAttribute('aria-pressed', b === sw ? 'true' : 'false'); });
    var img = card.querySelector('.vl-card__media img');
    if (img && sw.dataset.image) { img.removeAttribute('srcset'); img.src = sw.dataset.image; }
  });

  // Tiroir panier : code promo appliqué au panier (API panier Shopify), puis tiroir rafraîchi
  function refreshDrawer() {
    var drawer = document.querySelector('cart-drawer');
    if (!drawer || !drawer.getSectionsToRender) return Promise.resolve();
    var ids = drawer.getSectionsToRender().map(function (s) { return s.id; }).join(',');
    return fetch(window.location.pathname + '?sections=' + ids)
      .then(function (r) { return r.json(); })
      .then(function (sections) {
        drawer.getSectionsToRender().forEach(function (s) {
          var el = s.selector ? document.querySelector(s.selector) : document.getElementById(s.id);
          if (el && sections[s.id]) el.innerHTML = drawer.getSectionInnerHTML(sections[s.id], s.selector);
        });
      });
  }
  window.vlRefreshDrawer = refreshDrawer;

  // Cadeau (sac de lavage) : 1 dans le panier dès qu'il y a assez d'articles, 0 sinon
  var giftBusy = false;
  function giftSync() {
    var drawer = document.querySelector('cart-drawer[data-vl-gift]');
    if (!drawer || giftBusy) return Promise.resolve();
    var giftId = parseInt(drawer.dataset.vlGift, 10);
    var min = parseInt(drawer.dataset.vlGiftMin, 10) || 2;
    giftBusy = true;
    return fetch('/cart.js', { headers: { Accept: 'application/json' } })
      .then(function (r) { return r.json(); })
      .then(function (cart) {
        var paid = 0, line = null;
        cart.items.forEach(function (it) { if (it.variant_id === giftId) line = it; else paid += it.quantity; });
        var want = paid >= min ? 1 : 0;
        var have = line ? line.quantity : 0;
        if (want === have) return;
        var req = have === 0
          ? fetch('/cart/add.js', { method: 'POST', headers: { 'Content-Type': 'application/json', Accept: 'application/json' }, body: JSON.stringify({ items: [{ id: giftId, quantity: 1 }] }) })
          : fetch('/cart/change.js', { method: 'POST', headers: { 'Content-Type': 'application/json', Accept: 'application/json' }, body: JSON.stringify({ id: line.key, quantity: want }) });
        return req.then(refreshDrawer);
      })
      .catch(function () {})
      .finally(function () { giftBusy = false; });
  }
  window.vlGiftSync = giftSync;
  if (typeof subscribe === 'function' && typeof PUB_SUB_EVENTS !== 'undefined') subscribe(PUB_SUB_EVENTS.cartUpdate, function () { giftSync(); });
  giftSync();
  document.addEventListener('click', function (e) {
    var btn = e.target.closest('[data-vl-promo-apply]');
    if (!btn) return;
    var box = btn.closest('[data-vl-promo]');
    var code = box.querySelector('[data-vl-promo-input]').value.trim();
    var status = box.querySelector('[data-vl-promo-status]');
    if (!code) return;
    btn.disabled = true;
    fetch((window.routes && window.routes.cart_update_url ? window.routes.cart_update_url : '/cart/update') + '.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
      body: JSON.stringify({ discount: code })
    })
      .then(function (r) { return r.json(); })
      .then(function (cart) {
        var ok = (cart.discount_codes || []).some(function (d) { return d.code.toLowerCase() === code.toLowerCase() && d.applicable; });
        return refreshDrawer().then(function () {
          var s = document.querySelector('[data-vl-promo-status]');
          if (s) s.textContent = ok ? 'Code « ' + code + ' » appliqué.' : 'Ce code n’est pas valide pour ce panier.';
        });
      })
      .catch(function () { status.textContent = 'Erreur, réessayez.'; })
      .finally(function () { btn.disabled = false; });
  });

  // Compte à rebours du panier (comme Luveon) : repart à chaque ouverture, s'efface à 0
  (function () {
    var drawer = document.querySelector('cart-drawer');
    if (!drawer) return;
    var deadline = 0, timer = 0, wasOpen = false;
    function tick() {
      var box = drawer.querySelector('[data-vl-cart-timer]');
      var clock = box && box.querySelector('[data-vl-cart-countdown]');
      if (!box || !clock || !deadline) return;
      var s = Math.max(0, Math.ceil((deadline - Date.now()) / 1000));
      box.hidden = s === 0;
      if (s === 0) return;
      var label = String(Math.floor(s / 60)).padStart(2, '0') + ':' + String(s % 60).padStart(2, '0');
      if (clock.textContent !== label) clock.textContent = label;
    }
    function sync() {
      var open = drawer.classList.contains('active');
      if (open === wasOpen) return;
      wasOpen = open;
      clearInterval(timer); timer = 0;
      if (!open) { deadline = 0; return; }
      var box = drawer.querySelector('[data-vl-cart-timer]');
      var secs = box ? parseInt(box.dataset.seconds, 10) || 298 : 298;
      deadline = Date.now() + secs * 1000;
      tick();
      timer = setInterval(tick, 500);
    }
    new MutationObserver(sync).observe(drawer, { attributes: true, attributeFilter: ['class'] });
    sync();
  })();
})();
